module.exports = __webpack_public_path__ + "static/media/incorrect.dbc8445a.jpg";